import React from 'react';
import Summary from '@/components/Summary';

// interface ProductInfo {
//   name: string;
//   code: string;
//   type: string;
//   establishDate: string;
//   scale: string;
//   managementFee: string;
//   riskLevel: string;
//   riskLevelColor: string;
//   fundManager: string;
//   tenure: string;
//   minPurchase: string;
// }

// interface BasicInfoCompProps {
//   selected?: boolean;
//   onSelectChange?: (checked: boolean) => void;
// }

const BasicInfoComp: React.FC<any> = ({ selected = false, onSelectChange, totalData }) => {
  const productInfo = totalData?.product_info || [];
  const product1 = productInfo[0] || {};
  const product2 = productInfo[1] || {};

  // 获取风险等级颜色
  const getRiskLevelColor = (riskLevel: string) => {
    if (riskLevel?.includes('中高风险')) return 'text-red-600';
    if (riskLevel?.includes('中低风险')) return 'text-blue-600';
    if (riskLevel?.includes('中等风险')) return 'text-orange-600';
    return 'text-gray-600';
  };

  const fields = [
    { key: '产品名称', label: '产品' },
    { key: '基金代码', label: '基金代码' },
    { key: '基金类型', label: '基金类型' },
    { key: '成立时间', label: '成立时间' },
    { key: '规模', label: '基金规模' },
    { key: '管理费率', label: '管理费率' },
    { key: '风险等级', label: '风险等级' },
    { key: '基金经理', label: '基金经理' },
    { key: '任职年限', label: '任职年限' },
    { key: '跟踪指数', label: '跟踪指数' }
  ];

  return (
    <div className="mb-3 flex flex-col gap-3 rounded-lg border border-gray-200 bg-white p-3">
      {/* 标题行 */}
      <div className="flex items-center gap-2">
        <div className="flex items-center gap-2">
          <input
            type="checkbox"
            checked={selected}
            onChange={e => onSelectChange?.(e.target.checked)}
            className="h-4 w-4 rounded border border-gray-300"
          />
          <span className="text-base font-semibold text-gray-900">基础信息对比</span>
        </div>
      </div>

      {/* 对比表格 */}
      <div className="flex overflow-hidden rounded-lg border border-gray-200">
        {/* 字段列 */}
        <div className="flex w-[93px] flex-col bg-gray-50">
          <div className="rounded-tl-lg bg-gray-100 px-2 py-1">
            <span className="text-xs font-semibold text-gray-900">产品</span>
          </div>
          {fields.slice(1).map(field => (
            <div key={field.key} className="border-t border-gray-200 px-2 py-1">
              <span className="text-xs text-gray-900">{field.label}</span>
            </div>
          ))}
        </div>

        {/* 产品1列 */}
        <div className="flex min-w-0 flex-1 flex-col bg-blue-50/50">
          <div className="truncate rounded-tr-lg bg-blue-100/10 px-2 py-1">
            <span
              className="w-full truncate text-xs font-semibold text-blue-600"
              title={product1.产品名称 || '无'}
            >
              {product1.产品名称 || '无'}
            </span>
          </div>
          <div className="border-t border-gray-200 px-2 py-1">
            <span className="text-xs text-gray-900">{product1.基金代码 || '无'}</span>
          </div>
          <div className="border-t border-gray-200 px-2 py-1">
            <span className="text-xs text-gray-900">{product1.基金类型 || '无'}</span>
          </div>
          <div className="border-t border-gray-200 px-2 py-1">
            <span className="text-xs text-gray-900">{product1.成立时间 || '无'}</span>
          </div>
          <div className="border-t border-gray-200 px-2 py-1">
            <span className="text-xs text-gray-900">{product1.规模 || '无'}</span>
          </div>
          <div className="border-t border-gray-200 px-2 py-1">
            <span className="text-xs text-gray-900">{product1.管理费率 || '无'}</span>
          </div>
          <div className="border-t border-gray-200 px-2 py-1">
            <span className={`text-xs font-semibold ${getRiskLevelColor(product1.风险等级)}`}>
              {product1.风险等级 || '无'}
            </span>
          </div>
          <div className="border-t border-gray-200 px-2 py-1">
            <span className="text-xs text-gray-900">{product1.基金经理 || '无'}</span>
          </div>
          <div className="border-t border-gray-200 px-2 py-1">
            <span className="text-xs text-gray-900">{product1.任职年限 || '无'}</span>
          </div>
          <div className="border-t border-gray-200 px-2 py-1">
            <span className="text-xs text-gray-900">{product1.跟踪指数 || '无'}</span>
          </div>
        </div>

        {/* 产品2列 */}
        <div className="flex min-w-0 flex-1 flex-col bg-orange-50/60">
          <div className="truncate rounded-tr-lg bg-orange-100/10 px-2 py-1">
            <span
              className="w-full truncate text-xs font-semibold text-orange-600"
              title={product2.产品名称 || '无'}
            >
              {product2.产品名称 || '无'}
            </span>
          </div>
          <div className="border-t border-gray-200 px-2 py-1">
            <span className="text-xs text-gray-900">{product2.基金代码 || '无'}</span>
          </div>
          <div className="border-t border-gray-200 px-2 py-1">
            <span className="text-xs text-gray-900">{product2.基金类型 || '无'}</span>
          </div>
          <div className="border-t border-gray-200 px-2 py-1">
            <span className="text-xs text-gray-900">{product2.成立时间 || '无'}</span>
          </div>
          <div className="border-t border-gray-200 px-2 py-1">
            <span className="text-xs text-gray-900">{product2.规模 || '无'}</span>
          </div>
          <div className="border-t border-gray-200 px-2 py-1">
            <span className="text-xs text-gray-900">{product2.管理费率 || '无'}</span>
          </div>
          <div className="border-t border-gray-200 px-2 py-1">
            <span className={`text-xs font-semibold ${getRiskLevelColor(product2.风险等级)}`}>
              {product2.风险等级 || '无'}
            </span>
          </div>
          <div className="border-t border-gray-200 px-2 py-1">
            <span className="text-xs text-gray-900">{product2.基金经理 || '无'}</span>
          </div>
          <div className="border-t border-gray-200 px-2 py-1">
            <span className="text-xs text-gray-900">{product2.任职年限 || '无'}</span>
          </div>
          <div className="border-t border-gray-200 px-2 py-1">
            <span className="text-xs text-gray-900">{product2.跟踪指数 || '无'}</span>
          </div>
        </div>
      </div>

      {/* AI总结部分 */}
      <Summary
        title="AI总结-投资策略"
        content={
          totalData?.投资策略 ||
          '两只产品在申购状态上存在差异：其中一只为正常申购，另一只是限制大额申购；赎回状态均为正常赎回。这通常体现了规模控制与持仓稳定的管理诉求，两只产品在资金管理与投资策略侧重上可能存在一定差异。'
        }
        isShowSuggestions={false}
      />
    </div>
  );
};

export default BasicInfoComp;
